// extracted by mini-css-extract-plugin
module.exports = {"root":"EABD2CaseTabContentContainer_root__1hlqP"};